import { useInfiniteQuery } from 'react-query';
import { useAuth } from '../contexts/auth-context';

import axios from '../utils/axios';

const getNotifications = async ({ pageParam }) => {
  const response = await axios.get(`/api/notification`, {
    params: {
      cursor: pageParam,
    },
  });
  return response.data;
};

const useNotifications = () => {
  const { isAuthenticated } = useAuth();
  return useInfiniteQuery('notifications', getNotifications, {
    getNextPageParam: (lastPage) =>
      lastPage?.info?.nextCursor || lastPage?.info?.bottomCursor || undefined,
    enabled: !!isAuthenticated,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export default useNotifications;
